/** Shared by the editorial prose sections; own module for react-refresh. */
export const SOURCE_CITE_CLASS = 'mt-2 block text-[11px] not-italic text-gray-400'

/** The sections' hairline list shell — adjacent in the footer zone, so they must not diverge. */
export const PROSE_LIST_CLASS = 'max-w-[760px] divide-y divide-gray-200'
